import { Controller } from 'react-hook-form'
import { ArrowDropDown } from '@mui/icons-material'
import { FormControl, InputLabel, Select } from '@mui/material'
import PropTypes from 'prop-types'

const FormInputSelect = ({
    children,
    className = '',
    color = 'primary',
    control,
    isDisabled = false,
    isReadOnly = false,
    label = '',
    name,
    rules,
    size = 'medium',
    sx = {},
    variant = 'outlined',
}) => {
    return (
        <FormControl
            className={className}
            color={color}
            disabled={isDisabled}
            margin="none"
            size={size}
            sx={[sx, ...(Array.isArray(sx) ? sx : [sx])]}
            variant={variant}
        >
            {label.length ? (
                <InputLabel
                    htmlFor={`select-${name}`}
                    id={`select-${name}-label`}
                >
                    {label}
                </InputLabel>
            ) : null}
            <Controller
                control={control}
                name={name}
                render={({ field: { onBlur, onChange, ref, value } }) => (
                    <Select
                        disableUnderline={isDisabled || isReadOnly}
                        IconComponent={() => (isDisabled || isReadOnly ? null : <ArrowDropDown color="action" />)}
                        id={`select-${name}`}
                        inputProps={{
                            'data-testid': `select-${name}-input`,
                        }}
                        inputRef={ref}
                        label={label}
                        labelId={`select-${name}-label`}
                        value={value || ''}
                        onBlur={onBlur}
                        onChange={onChange}
                    >
                        {children}
                    </Select>
                )}
                rules={rules}
            />
        </FormControl>
    )
}

FormInputSelect.propTypes = {
    children: PropTypes.node.isRequired,
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    color: PropTypes.string,
    isDisabled: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    label: PropTypes.string,
    rules: PropTypes.object,
    size: PropTypes.string,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
    variant: PropTypes.string,
}

export default FormInputSelect
